import { withEditableArea } from '@trendkite/ui';
import EditStoryVideos from './EditStoryVideos';
import StoryVideosDisplay from './StoryVideosDisplay';

export default withEditableArea(StoryVideosDisplay, EditStoryVideos);
